export const APP_CODE = 'TELCO_NPP';
export const LANGUAGE = 'vi';
export const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY';
export const FORMAT_DATE_DASH = 'DD-MM-YYYY';
export const NORMALIZE_PRESIGN_LINK_FIELDS = [
  'frontDocumentFile',
  'backDocumentFile',
  'enterprisePermitFile',
  'contactSelfieImage',
  'contactSignatureImage',
  'legalPeopleFile',
  'powerOfAttorneyFile',
  'negotiatorImgFile',
  'commonConditionFile',
  'contractTermFile',
  'signatureImgFile',
];
export const EXTERNAL_MENU_FLAG = '?external=true';
export const EXTERNAL_MENU_KEYS = {
  UPDATE_SUBS_REQ:
    process.env.REACT_APP_ENTERPRISE_PORTAL_URL + '/management/update-sub-requests/list',
};
export const DEFAULT_IMAGE_FALLBACK =
  'data:image/png;base64,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';

export const USER_MENU_KEYS = {
  CHANGE_PASSWORD: 'change-password',
  LOGOUT: 'logout',
};

export const PASSWORD_CONFIG = {
  MIN_LENGTH: 9,
  REGEX: {
    DIGIT: /\d/,
    LOWERCASE: /[a-z]/,
    UPPERCASE: /[A-Z]/,
    SPECIAL_CHAR: /[!@#$%^&*()_+\-={};':"\\|,.<>/?]/,
  },
};

export const TIMEOUT = {
  FOCUS_DELAY: 100,
  SUCCESS_MESSAGE_DURATION: 1.5,
  REDIRECT_DELAY: 1500,
};

export const ERROR_MESSAGES = {
  REQUIRED_NEW_PASSWORD: 'Vui lòng nhập mật khẩu mới',
  MIN_LENGTH: `Mật khẩu phải có ít nhất ${PASSWORD_CONFIG.MIN_LENGTH} ký tự`,
  MISSING_DIGIT: 'Mật khẩu phải chứa ít nhất 1 chữ số (0-9)',
  MISSING_LOWERCASE: 'Mật khẩu phải chứa ít nhất 1 chữ thường (a-z)',
  MISSING_UPPERCASE: 'Mật khẩu phải chứa ít nhất 1 chữ in hoa (A-Z)',
  MISSING_SPECIAL_CHAR: 'Mật khẩu phải chứa ít nhất 1 ký tự đặc biệt (!@#$%^&*.)',
  SAME_AS_CURRENT: 'Mật khẩu mới không được trùng với mật khẩu hiện tại',
  REQUIRED_CONFIRM: 'Vui lòng xác nhận mật khẩu mới',
  CONFIRM_NOT_MATCH: 'Mật khẩu xác nhận không khớp',
  WHITESPACE_ONLY: 'Mật khẩu không được chỉ chứa khoảng trắng',
  CURRENT_PASSWORD_INCORRECT: 'Mật khẩu hiện tại không chính xác',
  TIMEOUT: 'Yêu cầu đã hết thời gian chờ. Vui lòng thử lại',
  GENERIC_ERROR: 'Đã có lỗi xảy ra. Vui lòng thử lại',
  CHANGE_FAILED: 'Đổi mật khẩu thất bại. Vui lòng thử lại',
  REQUIRED_CURRENT_PASSWORD: 'Vui lòng nhập mật khẩu hiện tại',
  DEFAULT: 'Đã có lỗi xảy ra. Vui lòng thử lại sau',
};

export const SUCCESS_MESSAGE_CHANGE_PASSWORD = {
  TITLE: 'Thành công',
  CHANGE_SUCCESS: 'Đổi mật khẩu thành công',
};

export const PASSWORD_REQUIREMENTS: string[] = [
  `Độ dài tối thiểu ${PASSWORD_CONFIG.MIN_LENGTH} ký tự`,
  'Bao gồm ít nhất 1 chữ số (0-9)',
  'Bao gồm ít nhất 1 chữ thường (a-z)',
  'Bao gồm ít nhất 1 chữ in hoa (A-Z)',
  'Bao gồm ít nhất 1 ký tự đặc biệt (!@#$%^&*...)',
  'Mật khẩu mới không được trùng mật khẩu cũ',
];

export const SESSION_KEY = 'forgot-password-session';
export const SESSION_TIMEOUT = 3 * 60 * 1000;

export const SUCCESS_CODE = 'S200';
export const DEFAULT_MAX_VERIFY_ATTEMPTS = 5;
export const MILLISECONDS_MULTIPLIER = 1000;

export const DEFAULT_VALUE = {
  DEFAULT_VALUE_VERIFY_ATTEMPTS: 0,
  MIN_TIMER_THRESHOLD: 0,
  DEFAULT_VALUE_VERIFY_IN_SECOND: 900,
};

export const OTP_TYPE = {
  EMAIL: 1,
  SMS: 0,
};

export const FORGOT_PASSWORD_STEP = {
  METHOD_SELECTION: 'method_selection',
  VERIFY_INFO: 'verify_info',
  OTP_INPUT: 'otp_input',
  NEW_PASSWORD: 'new_password',
  SUCCESS: 'success',
};

export const OTP_LENGTH = 6;

export const DESTINATION_LABEL = {
  EMAIL: 'email',
  SMS: 'SĐT',
};

export const OTP_MESSAGES = {
  VERIFY_SUCCESS: 'Xác thực OTP thành công',
  VERIFY_LOCKED: 'Bạn đã nhập sai quá nhiều lần. Vui lòng thử lại sau',
  VERIFY_INCORRECT: (remaining: number) => `Mã OTP không chính xác. Còn ${remaining} lần thử`,
  VERIFY_EXPIRED: (remaining: number) => `Mã OTP đã hết hiệu lực. Còn ${remaining} lần thử`,
  VERIFY_ERROR: 'Có lỗi xảy ra. Vui lòng thử lại',
  RESEND_LOCKED: 'Bạn đã hết lượt gửi lại mã',
  RESEND_EXHAUSTED: (time: string) => `Bạn đã hết lượt gửi OTP. Vui lòng thử lại sau ${time}`,
  RESEND_SUCCESS: (destination: string, identifier: string) =>
    `Mã xác thực đã được gửi lại đến ${destination}: ${identifier}`,
  RESEND_ERROR: 'Có lỗi xảy ra',
};

export enum JOB_STATUS {
  Pending,
  Processing,
  Done,
  Failed,
}
